import { Button, Form } from "react-bootstrap";
import { Modal, MuniSpinner2 } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import useActas from "../../../api/actas";
import { useContext, useEffect, useState } from "react";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { marcarPagoDictamenHandler } from "../../../handlers/accionActa.handler";
import { UserContext } from "../../../context";

const ModalPago = ({ modals, handlerModal, setRefetch }) => {

    //? ESTADOS GLOBALES
    const { loads } = useGeneralAppStore();
    const { actaDetalle } = useActaDetalleStore();

    //TODO API
    const { cambiarEstadoDescargo } = useActas();
    const [numeroComprobante, setNumeroComprobante] = useState("");
    const [fechaPago, setFechaPago] = useState("");
    const { actions } = useContext(UserContext);

    useEffect(() => {
        return () => {
            handlerModal({ modal: false, modalName: "modal_pago_dictamen" })
        }
    }, [])
    return (
        <Modal
            show={modals.includes('modal_pago_dictamen')}
            size={"md"}
            onHide={() => handlerModal({ modal: false, modalName: "modal_pago_dictamen" })}
            title={() => "Marcar acta como pagada"}
        >

            <div className="d-flex flex-column gap-2 position-relative">
                {
                    loads.includes('load_pago_dictamen') &&
                    <div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center " style={{ background: "rgba(255,255,255,0.8)", zIndex: "999" }}>
                        <MuniSpinner2 />
                    </div>

                }
                <Form.Group>
                    <Form.Label>N° de comprobante: </Form.Label>
                    <Form.Control
                        defaultValue={numeroComprobante}
                        type="text"
                        onChange={(e) => { setNumeroComprobante(e.target.value) }}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label>Fecha Pago: </Form.Label>
                    <Form.Control
                        defaultValue={fechaPago}
                        onChange={(e) => { setFechaPago(e.target.value) }}
                        type="date"
                    // style={{ resize: "none" }}
                    // as={'text'}
                    // rows={4}
                    />
                </Form.Group>
                <div style={{ minHeight: "50px" }} className="d-flex flex-column">
                    {(numeroComprobante == "") && <span className="text-danger">Debe indicar el numero de comprobante</span>}
                    {(fechaPago == "") && <span className="text-danger">Debe indicar la fecha de pago</span>}
                </div>
                <hr />
                <div className="d-flex justify-content-end gap-2">
                    <Button
                        variant="dark"
                        size="sm"
                        style={{ width: "fit-content" }}
                        onClick={() =>
                            marcarPagoDictamenHandler({ id: actaDetalle.acta.dictamenes[0].id, numero_comprobante: numeroComprobante, fecha_pago: fechaPago }, setRefetch)
                        }
                        disabled={loads.includes('load_pago_dictamen') || (numeroComprobante == "") || (fechaPago == "")}
                    >
                        {loads.includes('load_pago_dictamen')
                            ? "Guardando cambios..."
                            : "Marcar como pagada"}
                    </Button>
                    {/* {
                        actions?.hasPermission('dictamen.pagovoluntario.create') &&
                        <Button
                            variant="dark"
                            size="sm"
                            style={{ width: "fit-content" }}
                            onClick={() =>
                                // dictaminarActaHandler({ generar_pago: true, numero_acta: actaDetalle.acta.numero_infraccion, observacion: observacion, numero_expediente: expediente }, setRefetch)
                                dictaminarActaHandler({ numero_acta: actaDetalle.acta.numero_infraccion, observacion: observacion, numero_expediente: expediente }, setRefetch)
                            }
                            disabled={loads.includes('dictamen') || (observacion == "") || (expediente == "")}
                        >
                            {loads.includes('dictamen')
                                ? "Guardando cambios..."
                                : "Dictaminar generando pago"}
                        </Button>
                    } */}
                </div>
            </div>

        </Modal>
    );
}
export default ModalPago;